import type { Id } from "@codesandbox/pitcher-client";
import { useAddStatusNotification } from "features/notifications/hooks";
import { usePitcher } from "features/utils/usePitcher";

import { useAnalytics } from "hooks/useAnalytics";
import { downloadFile } from "utils/downloadFile";

import type { Command } from "../../types";

export const useExplorerDownloadCommand = (
  props: {
    fileId?: Id;
    type: string;
  } = { type: "" },
): Command => {
  const track = useAnalytics();
  const pitcher = usePitcher();
  const addNotification = useAddStatusNotification();

  return {
    name: "Download to ZIP",
    id: "codesandbox.files.download",
    section: "Filesystem",
    perform: async () => {
      let path = undefined;
      if (props.fileId) {
        const filepath = pitcher.clients.file.getPathFromFileId(props.fileId);

        if (filepath) {
          path = pitcher.clients.fs.relativeToAbsoluteWorkspacePath(filepath);
        }
      }

      track("download", { tag: props.type });
      try {
        const { downloadUrl } = await pitcher.clients.fs.download(path);
        downloadFile(downloadUrl);
      } catch (e) {
        if (e instanceof Error) {
          addNotification({
            message: "Failed to download zip: " + e.message,
            status: "error",
          });
        } else {
          addNotification({
            message: "Failed to download zip",
            status: "error",
          });
        }
      }
    },
  };
};
